/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        ManagerPortal.UI
//   Object:     fontawesome.js
//   Details:    fontawesome library
//               This library allows font awesome icons to be imported once, rather than in each individual class they are required
//
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 105066 06/01/20 JC       New
// 110638 02/02/21 JC  M01  Added faBars
// WI3713 31/01/24 JC  M02JC    Added faSpinner, faExclamation
//-------------------------------------------------------
*/


// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
import {

    faExclamationCircle,
    faInfoCircle,
    faCheck,
    faClock,
    faTimes,

    faPrint,
    faTimesCircle,
    //faSearch,
    faFile,
    faGraduationCap,
    faGlobeAmericas,
    faEnvelope,

    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faStepForward,
    faStepBackward,

    faLock,
    faSave,

    faTrashAlt,

    faBars, //M01
    faSpinner, //M02JC
    faExclamation //M02JC


} from "@fortawesome/free-solid-svg-icons";


//add to library
library.add(
    faExclamationCircle,
    faInfoCircle,
    faCheck,
    faClock,
    faTimes,

    faPrint,
    faTimesCircle,
    //faSearch,
    faFile,
    faGraduationCap,
    faGlobeAmericas,
    faEnvelope,

    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faStepForward,
    faStepBackward,

    faLock,
    faSave,

    faTrashAlt,

    faBars, // M01
    faSpinner, //M02JC
    faExclamation //M02JC

    // more icons go here
);
